<template>
	<v-card>
		<v-card-title>
			<h3>Oferty</h3>
		</v-card-title>
		<BidderOfferList :only-mine="false"/>
	</v-card>
</template>

<script>
	import BidderOfferList from "../offer/components/BidderOfferList";

	export default {
		name: "BidderOfferView",
		components: {BidderOfferList}
	};
</script>

<style scoped>

</style>
